import React, { useEffect, useState } from 'react'
import { Title } from '../title/title.jsx'
import { getLocalPath } from '../../utility/config/configuration'

export const InvestorLogin = () => {
  const [loginData, setLoginData] = useState(null)
  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const data = (await getLoginData())?._embedded?.documents || []
    setLoginData(data)
  }

  const getLoginData = async () => {
    const url = `${getLocalPath()}/halapi/documents?_scope=/content/documents/cti-investor/login-and-registration/login-prompts&_sort=cti:meta`
    const response = await fetch(url)
    return response.ok ? await response.json() : {}
  }

  return (
    <div className="u-sizeConstrained u-paddingTop12gu u-paddingBottom12gu">
      <div className="u-flex">
        <Title
          text="Log in to your accounts"
          mode="medium-line"
          lineColor="u-bgColorBrand"
        />
      </div>

      <div className="u-paddingTop5gu u-flex u-flexJustifyBetween">
        {loginData?.map((prompt) => (
          <div
            key={prompt.title}
            className="u-flex u-flexCol u-size3of10 u-flexJustifyBetween"
          >
            <div>
              <Title text={prompt.title} mode="small" />
              <p className="u-marginTop1gu u-marginBottom3gu u-paddingBottom3gu u-sm-paddingBottom0">
                {prompt.subtitle}
              </p>
            </div>
            <a
              key={prompt.title}
              href={prompt.LinkCompound.Link[0].string}
              target="_blank"
              rel="noopener noreferrer"
              className="Button Button--secondary Button--block u-textUppercase u-paddingHoriz8gu"
              data-analytics={`login--${prompt.title
                .replaceAll(' ', '-')
                .toLowerCase()}`}
            >
              Log In
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}
